import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import store from "../store/index";

var children = [
	{
		path: "/KuJiaLe",
		name: "KuJiaLe",
		meta: {
			title: '设计'
		},
		// component: () => import ("../views/KuJiaLe.vue")
	},
	{
		path: "/OrderSystem",
		name: "OrderSystem",
		meta: {
			title: '订单系统'
		},
		component: () => import ("../views/OrderSystem.vue")
	},
	{
		path: "/ProcessMgt",
		name: "ProcessMgt",
		meta: {
			title: '流程管理'
		},
		component: () => import ("../views/ProcessMgt.vue")
	},
	{
		path: "/Setting",
		name: "Setting",
		meta: {
			title: '设置'
		},
		component: () => import ("../views/Setting.vue")
	},
	{
		path: "/403",
		name: "403",
		meta: {
			title: '没有权限'
		},
		component: () => import ("../views/Error403.vue")
	},
];
if (process.env.NODE_ENV == "production" || process.env.NODE_ENV == "development"){
	children.push({
		path: "/Login",
		name: "Login",
		meta: {
			title: '科凡登录'
		},
		component: () => import ("../views/Login.vue")
	});
	children.push({
		path: "/Login2",
		name: "Login2",
		meta: {
			title: '智绘佳登录'
		},
		component: () => import ("../views/Login2.vue")
	});
}
if (process.env.NODE_ENV == "development"){
	children.push({
		path: "/AuditOrderSystem",
		name: "AuditOrderSystem",
		meta: {
			title: '拆单系统'
		},
		component: () => import ("../views/AuditOrderSystem.vue")
	});
	children.push({
		path: "/LogSystem",
		name: "LogSystem",
		meta: {
			title: '系统日志'
		},
		component: () => import ("../views/LogSystem.vue")
	});
}

if (process.env.NODE_ENV == "kefan"){
	children.push({
		path: "/Login",
		name: "Login",
		meta: {
			title: '科凡登录'
		},
		component: () => import ("../views/Login.vue")
	});
}
if (process.env.NODE_ENV == "zhj"){
	children.push({
		path: "/Login",
		name: "Login",
		meta: {
			title: '智绘佳登录'
		},
		component: () => import ("../views/Login2.vue")
	});
}

const routes = [
    {
        path: '/',
        redirect: '/OrderSystem'
    }, 
	{
		path: '/',
		name: 'Home',
		component: HomeView,
		children:children,
	},
	// {
	// 	path: '/about',
	// 	name: 'about',
	// 	// route level code-splitting
	// 	// this generates a separate chunk (about.[hash].js) for this route
	// 	// which is lazy-loaded when the route is visited.
	// 	component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
	// }
]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes
})

router.beforeEach((to, from, next) => {
	// console.log(store.state.windowWidth);
	// console.log(to);

	if (to.name != 'Login' && (!store.state.userType || store.state.userType == '')){
		next('/Login');
	} else if (to.name == 'KuJiaLe' && (!store.getters.hasKJL)) {
		next('/403');
	} else {
		next();
	}
})

export default router
